<template>
  <div class="pr-4">
    <div style="background-color: #fff; padding-bottom: 30px">
      <mdb-container>
        <mdb-row>
          <div class="progress__container">
            <img :src="treeImg" style="width: 100%; height: auto" alt />
          </div>
        </mdb-row>
      </mdb-container>
    </div>
    <mdb-row style="background-color: #e0e0e0">
      <mdb-col class="pr-5 pl-5">
        <mdb-tbl responsiveSm class="t1-table t1-table__home">
          <tr>
            <th>Pasos</th>
            <th>Estado</th>
            <th class="text-center">Corregir/Actualizar</th>
            <th class="text-center">Ayuda</th>
          </tr>
          <tr>
            <td v-if="!appId" class="t1-font-bold t1-orange-text">
              <div
                @click="$router.push('/home/curp')"
                style="cursor: pointer; display: inline-block"
              >
                Crear solicitud
                <img
                  @click="$router.push('/home/curp')"
                  style="cursor: pointer"
                  class="arrow-right"
                  src="/img/icons/arrow-right-orange.svg"
                />
              </div>
            </td>
            <td
              v-else-if="
                app.applicationStatus == 'IN_EDIT_BY_PARTNER_SERVICE' &&
                solicitud.correcting
              "
              class="t1-font-bold"
            >
              <div style="cursor: pointer; display: inline-block">
                Solicitud creada

                <mdb-popover trigger="hover" :options="{ placement: 'top' }">
                  <div
                    slot="body"
                    style="font-size:14px; color: #000; font-weight: 600;'>"
                  >
                    Corrige tus datos/documentos en este paso. Da clic sobre el
                    icono naranja de editar
                  </div>
                  <img
                    slot="reference"
                    class="arrow-right"
                    src="/img/icons/alert.svg"
                  />
                </mdb-popover>
              </div>
            </td>
            <td v-else class="t1-font-bold">Solicitud creada</td>

            <td
              v-if="
                app.applicationStatus == 'IN_EDIT_BY_PARTNER_SERVICE' &&
                solicitud.correcting
              "
            >
              Por corregir
            </td>
            <td v-else-if="!appId">Incompleto</td>
            <td v-else>Completo</td>

            <td
              v-if="
                app.applicationStatus == 'IN_EDIT_BY_PARTNER_SERVICE' &&
                solicitud.correcting
              "
              class="text-center"
            >
              <img
                @mouseup="mouseUpIcon('request')"
                @mousedown="mouseDownIcon('request')"
                @mouseleave="mouseLeaveIcon('request')"
                @mouseover="mouseOverIcon('request')"
                :src="'/img/icons/edit-hover.svg'"
                class="table-icon table-icon__watch"
                @click="$router.push('/home/updateInfo')"
              />
              <!-- <span class="table-icon__span">{{ requestSpanText }}</span> -->
            </td>
            <td v-else class="text-center"></td>

            <td>
              <span
                class="create-account"
                @click="
                  openVideo(
                    'https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemaSolicitudes-1-CrearSolicitud.mp4'
                  )
                "
                >Ver video</span
              >
            </td>
          </tr>
          <tr>
            <td
              :class="
                appId && !payAprob
                  ? 't1-orange-text t1-font-bold'
                  : 't1-font-bold'
              "
            >
              <!--<div
                @click="appId && !payAprob ? $router.push('/home/payment') : ''"
                :style="!payAprob ? 'cursor: pointer; display: inline-block;' : ''"
              >-->
              <div
                :style="
                  !payAprob ? 'cursor: pointer; display: inline-block;' : ''
                "
                @click="appId && !payAprob ? $router.push('/home/payment') : ''"
              >
                Pago online
                <img
                  v-if="!payAprob && appId"
                  class="arrow-right"
                  src="/img/icons/arrow-right-orange.svg"
                />
              </div>
            </td>
            <td v-if="payAprob">Completo</td>
            <td v-else>Incompleto</td>
            <td class="text-center">
              <!-- <img
                @mouseup="mouseUpIcon('payment')"
                @mousedown="mouseDownIcon('payment')"
                @mouseleave="mouseLeaveIcon('payment')"
                @mouseover="mouseOverIcon('payment')"
                :src="'/img/icons/'+paymentIcon"
                class="table-icon table-icon__watch"
              />
              <span class="table-icon__span">{{ paymentSpanText }}</span> -->
            </td>
            <td>
              <span
                class="create-account"
                @click="
                  openVideo(
                    'https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemaSolicitudes-2-PagOnline.mp4'
                  )
                "
                >Ver video</span
              >
            </td>
          </tr>
          <tr
            v-if="
              maritalStatus == 'MARRIED' &&
              payAprob &&
              app.membership.membershipName == 'Familiar'
            "
          >
            <td
              v-if="
                beneficiaries.length > 0 &&
                correctionsSpouse.length > 0 &&
                app.applicationStatus == 'IN_EDIT_BY_PARTNER_SERVICE'
              "
            >
              <div class="t1-font-bold">
                Datos del cónyuge
                <mdb-popover trigger="hover" :options="{ placement: 'top' }">
                  <div
                    slot="body"
                    style="font-size:14px; color: #000; font-weight: 600;'>"
                  >
                    Corrige tus datos/documentos en este paso. Da clic sobre el
                    icono naranja de editar
                  </div>
                  <img
                    slot="reference"
                    class="arrow-right"
                    src="/img/icons/alert.svg"
                  />
                </mdb-popover>
              </div>
            </td>
            <td v-else-if="beneficiaries.length > 0" class="t1-font-bold">
              Datos del cónyuge
            </td>
            <td v-else class="t1-font-bold t1-orange-text">
              <div
                @click="$router.push('/home/curp')"
                style="cursor: pointer; display: inline-block"
              >
                Datos de cónyuge
                <img
                  @click="$router.push('/home/curp')"
                  style="cursor: pointer"
                  class="arrow-right"
                  src="/img/icons/arrow-right-orange.svg"
                />
              </div>
            </td>

            <td
              v-if="
                beneficiaries.length > 0 &&
                correctionsSpouse.length > 0 &&
                app.applicationStatus == 'IN_EDIT_BY_PARTNER_SERVICE'
              "
            >
              Por corregir
            </td>
            <td v-else-if="beneficiaries.length > 0">Completo</td>
            <td v-else>Incompleto</td>

            <td
              v-if="
                beneficiaries.length > 0 &&
                correctionsSpouse.length > 0 &&
                app.applicationStatus == 'IN_EDIT_BY_PARTNER_SERVICE'
              "
              class="text-center"
            >
              <img
                @mouseup="mouseUpIcon('request')"
                @mousedown="mouseDownIcon('request')"
                @mouseleave="mouseLeaveIcon('request')"
                @mouseover="mouseOverIcon('request')"
                :src="'/img/icons/edit-hover.svg'"
                class="table-icon table-icon__watch"
                @click="$router.push('/home/updateInfoSpouse')"
              />
              <!-- <span class="table-icon__span">{{ requestSpanText }}</span> -->
            </td>
            <td v-else class="text-center"></td>
            <td>
              <span
                class="create-account"
                @click="
                  openVideo(
                    'https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemaSolicitudes-2.5-EnviarDatosConyuge.mp4'
                  )
                "
                >Ver video</span
              >
            </td>
          </tr>

          <tr v-if="app.applicationStatus == 'FINISHED'">
            <td class="t1-font-bold">
              <div>Documentación enviada</div>
            </td>
            <td>Completo</td>
            <td class="text-center"></td>
            <td>
              <span class="create-account">Ver video</span>
            </td>
          </tr>
          <tr v-else-if="app.applicationStatus == 'IN_EDIT_ACCEPTED'">
            <td class="t1-font-bold">
              <div>
                Corregir Documentación
                <mdb-popover trigger="hover" :options="{ placement: 'top' }">
                  <div
                    slot="body"
                    style="font-size:14px; color: #000; font-weight: 600;'>"
                  >
                    Corrige tus datos/documentos en este paso. Da clic sobre el
                    icono naranja de editar
                  </div>
                  <img
                    slot="reference"
                    class="arrow-right"
                    src="/img/icons/alert.svg"
                  />
                </mdb-popover>
              </div>
            </td>
            <td>Por corregir</td>

            <td class="text-center">
              <img
                @mouseup="mouseUpIcon('request')"
                @mousedown="mouseDownIcon('request')"
                @mouseleave="mouseLeaveIcon('request')"
                @mouseover="mouseOverIcon('request')"
                :src="'/img/icons/edit-hover.svg'"
                class="table-icon table-icon__watch"
                @click="$router.push('/home/updateInfoRemaining')"
              />
              <!-- <span class="table-icon__span">{{ uploadSpanText }}</span> -->
            </td>
            <td>
              <span class="create-account">Ver video</span>
            </td>
          </tr>
          <tr v-else>
            <!--HERE_1: appId && payAprob-->
            <!--documentsUp-->
            <td
              :class="
                documentsUp ? 't1-orange-text t1-font-bold' : 't1-font-bold'
              "
            >
              <div
                @click="documentsUp ? $router.push('/home/documentos') : ''"
                :style="
                  documentsUp ? 'cursor: pointer; display: inline-block;' : ''
                "
              >
                Subir documentos
                <img
                  v-if="documentsUp"
                  @click="documentsUp ? $router.push('/home/documentos') : ''"
                  class="arrow-right"
                  src="/img/icons/arrow-right-orange.svg"
                />

                <img
                  v-if="!documentsUp"
                  class="arrow-right"
                  src="/img/icons/arrow-right-grey.svg"
                />
              </div>
            </td>

            <td>Incompleto</td>
            <td class="text-center">
              <!-- <img
                @mouseup="mouseUpIcon('upload')"
                @mousedown="mouseDownIcon('upload')"
                @mouseleave="mouseLeaveIcon('upload')"
                @mouseover="mouseOverIcon('upload')"
                :src="'/img/icons/'+uploadDocsIcon"
                class="table-icon table-icon__watch"
              />
              <span class="table-icon__span">{{ uploadSpanText }}</span> -->
            </td>
            <td>
              <span
                class="create-account"
                @click="
                  openVideo(
                    'https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/videos-pasos/SistemasSolicitudes-3-SubirDocumentos.mp4'
                  )
                "
                >Ver video</span
              >
            </td>
          </tr>
        </mdb-tbl>
      </mdb-col>
    </mdb-row>
    <mdb-row style="background-color: #e0e0e0; padding-bottom: 100px">
      <mdb-col v-show="false">
        <div class="btn-sumit-home">
          <btn :type="btnState" :text="'Enviar'" :class="'btn-submit-home'" />
        </div>
      </mdb-col>
    </mdb-row>

    <Popup ref="termsPopX" size="md">
      <h4 class="login__title mb-4 custom_size">
        TERMINOS DE USO Y RECOPILACIÓN DE DATOS
      </h4>
    </Popup>

    <Popup ref="welcomemes" size="lg">
      <mdb-container>
        <div ref="screen1" v-if="welcomescreen == 1">
          <mdb-row>
            <mdb-col class="text-center">
              <h3 class="t1-title" style="margin-top: 0; text-transform: none">
                ¡Hola, bienvenid@ al sistema de solicitudes!
              </h3>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col class="text-center">
              <img
                src="/img/icons/welcome1.svg"
                class="mt-5"
                width="300px"
                height="auto"
                alt
              />
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col class="text-center mt-5">
              <p style="color: #4f4f4f; font-size: 20px; font-weight: 600">
                Antes de crear tu solitud de trámite de admisión es necesario
                que cuentes con los siguientes documentos
              </p>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col class="text-center">
              <span class="dot dot-colored"></span>
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col class="text-right">
              <div @click="welcomescreen++" style="cursor: pointer">
                <p
                  style="
                    display: inline;
                    font-weight: 300;
                    font-size: 18px;
                    color: #828282;
                  "
                >
                  Siguiente
                </p>
                <img
                  src="/img/icons/arrow-right-grey.svg"
                  style="padding-bottom: 5px; padding-left: 3px"
                  alt
                />
              </div>
            </mdb-col>
          </mdb-row>
        </div>
        <!-- welcomescreen -->

        <div ref="screen2" v-if="welcomescreen == 2">
          <mdb-row>
            <mdb-col class="text-left">
              <h5
                style="
                  font-size: 18px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  color: #4f4f4f;
                "
              >
                Paso 01 Crear solicitud:
              </h5>
            </mdb-col>
          </mdb-row>

          <mdb-row>
            <mdb-col md="8">
              <div class="option_text">
                <div class="dot"></div>
                Tomarte una foto al instante, la necesitamos para conocerte de
                una manera virtual, cuida que sea de frente y sin accesorios
                (gorros, lentes, etc.) que obstruyan tu rostro.
              </div>
              <!--option_text-->

              <div class="option_text">
                <div class="dot"></div>
                Foto (PNG/JPGE/JPG) o PDF de tu CURP (Actualizada)
              </div>
              <!--option_text-->

              <div class="option_text">
                <div class="dot"></div>
                Foto (PNG/JPGE/JPG) o PDF de tu identificación oficial
                INE/Pasaporte.
              </div>
              <!--option_text-->
            </mdb-col>

            <mdb-col md="4" class="text-center">
              <img
                src="/img/icons/welcome2.svg"
                style="margin-top: 30px"
                class
                width="180px"
                height="auto"
                alt
              />
            </mdb-col>
          </mdb-row>

          <mdb-row>
            <mdb-col md="4" class="text-center">
              <img
                src="/img/icons/IconoBienvenida03.svg"
                style="margin-top: 30px"
                class
                width="160px"
                height="auto"
                alt
              />
            </mdb-col>

            <mdb-col md="8">
              <div class="option_text">
                <div class="dot"></div>
                Constancia de situación fiscal de la empresa donde
                laboras/laboraste.
              </div>
              <!--option_text-->

              <div class="option_text">
                <div class="dot"></div>
                4 recomendaciones de socios del club, donde necesitarás por cada
                uno:
                <div style="margin-left: 25px; margin-top: 20px">
                  -Nombre completo del socio.
                </div>
                <div style="margin-left: 25px; margin-top: 10px">
                  -Su teléfono.
                </div>
                <div style="margin-left: 25px; margin-top: 10px">
                  -Su correo.
                </div>
                <div
                  style="
                    margin-left: 25px;
                    margin-top: 10px;
                    margin-bottom: 30px;
                  "
                >
                  -Su número de acción.
                </div>
              </div>
              <!--option_text-->
            </mdb-col>
          </mdb-row>

          <mdb-row>
            <mdb-col class="text-center">
              <span class="dot"></span>
              <span class="dot dot-colored"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col class="text-left">
              <div @click="welcomescreen--" style="cursor: pointer">
                <img
                  src="/img/icons/arrow-right-grey.svg"
                  style="
                    transform: rotate(180deg);
                    padding-top: 0.6rem;
                    padding-left: 3px;
                  "
                  alt
                />
                <p
                  style="
                    display: inline;
                    font-weight: 300;
                    font-size: 18px;
                    color: #828282;
                  "
                >
                  Atrás
                </p>
              </div>
            </mdb-col>
            <mdb-col class="text-right">
              <div @click="welcomescreen++" style="cursor: pointer">
                <p
                  style="
                    display: inline;
                    font-weight: 300;
                    font-size: 18px;
                    color: #828282;
                  "
                >
                  Siguiente
                </p>
                <img
                  src="/img/icons/arrow-right-grey.svg"
                  style="padding-bottom: 5px; padding-left: 3px"
                  alt
                />
              </div>
            </mdb-col>
          </mdb-row>
        </div>
        <!-- welcomescreen 2 -->

        <div ref="screen3" v-if="welcomescreen == 3">
          <!-- CUSTOM ROW -->
          <mdb-row>
            <mdb-col class="text-left">
              <h5
                style="
                  font-size: 18px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  color: #4f4f4f;
                "
              >
                Paso 02 Pago Online:
              </h5>
            </mdb-col>

            <mdb-col md="12">
              <div class="option_text">
                Para adquirir una casa o un terreno es necesario:
              </div>
              <!--option_text-->

              <div class="option_text">
                <div class="dot"></div>
                PDF de la escritura de la casa o terreno que deseas adquirir.
              </div>
              <!--option_text-->

              <div class="option_text">
                <div class="dot"></div>
                PDF del pago más reciente del predial de la casa o terreno que
                deseas adquirir.
              </div>
              <!--option_text-->

              <div class="option_text">
                <div class="dot"></div>
                Tarjeta bancaria de crédito o débito, Visa, MasterCard o
                AmericanExpress.
              </div>
              <!--option_text-->
            </mdb-col>
          </mdb-row>
          <!-- CUSTOM ROW -->

          <mdb-row>
            <mdb-col class="text-center">
              <img
                src="/img/icons/CustomIconoPago.png"
                class="mt-5"
                width="160px"
                height="auto"
                alt
              />
            </mdb-col>
          </mdb-row>

          <!--<mdb-row class="mt-5 mb-5">
            <mdb-col class="text-center">
              <Btn type="primary" @onClick="$router.push('/home/curp')" text="Iniciar"/>
            </mdb-col>
          </mdb-row>-->

          <mdb-row>
            <mdb-col class="text-center">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot dot-colored"></span>
              <span class="dot"></span>
            </mdb-col>
          </mdb-row>

          <mdb-row>
            <mdb-col class="text-left">
              <div @click="welcomescreen--" style="cursor: pointer">
                <img
                  src="/img/icons/arrow-right-grey.svg"
                  style="
                    transform: rotate(180deg);
                    padding-top: 0.6rem;
                    padding-left: 3px;
                  "
                  alt
                />
                <p
                  style="
                    display: inline;
                    font-weight: 300;
                    font-size: 18px;
                    color: #828282;
                  "
                >
                  Atrás
                </p>
              </div>
            </mdb-col>

            <mdb-col class="text-right">
              <div @click="welcomescreen++" style="cursor: pointer">
                <p
                  style="
                    display: inline;
                    font-weight: 300;
                    font-size: 18px;
                    color: #828282;
                  "
                >
                  Siguiente
                </p>
                <img
                  src="/img/icons/arrow-right-grey.svg"
                  style="padding-bottom: 5px; padding-left: 3px"
                  alt
                />
              </div>
            </mdb-col>
          </mdb-row>
        </div>
        <!--screen 3 -->

        <div ref="screen4" v-if="welcomescreen == 4">
          <mdb-row>
            <mdb-col md="12">
              <div class="option_text">
                Si tu estado civil es
                <strong>Casado</strong> y seleccionas para tu trámite de
                <strong>admisión una Acción Familiar</strong> deberás contar con
                los datos de tu Cónyuge:
              </div>
              <!--option_text-->
            </mdb-col>

            <mdb-col md="8">
              <div class="option_text">
                <div class="dot"></div>
                Tomarle una foto al instante, la necesitamos para conocerl@ de
                una manera virtual, cuida que sea de frente y sin accesorios
                (gorros, lentes,etc.) que obstruyan su rostro.
              </div>
              <!--option_text-->

              <div class="option_text">
                <div class="dot"></div>
                Foto (PNG/JPGE/JPG) o PDF de su CURP (Actualizada).
              </div>
              <!--option_text-->

              <div class="option_text">
                <div class="dot"></div>
                Foto (PNG/JPGE/JPG) o PDF de su identificación oficial
                INE/Pasaporte.
              </div>
              <!--option_text-->

              <div class="option_text">
                <div class="dot"></div>
                Constancia de situación fiscal de la empresa donde
                labora/laboró.
              </div>
              <!--option_text-->
            </mdb-col>

            <mdb-col md="4" class="text-center">
              <img
                src="/img/icons/welcome2.svg"
                style="margin-top: 30px"
                class
                width="180px"
                height="auto"
                alt
              />
            </mdb-col>
          </mdb-row>

          <mdb-row>
            <mdb-col md="2" class="text-center">
              <img
                src="/img/icons/InoAlerta.svg"
                style="margin-top: 30px"
                class
                width="120px"
                height="auto"
                alt
              />
            </mdb-col>

            <mdb-col md="10">
              <div
                class="option_text"
                style="color: #dc7134 !important; margin-top: 30px !important"
              >
                <strong>¡IMPORTANTE!</strong>
              </div>
              <!--option_text-->

              <div class="option_text" style="margin-top: 10px !important">
                Sin todos estos documentos no podrás generar tu solicitud de
                admisión
              </div>
              <!--option_text-->
            </mdb-col>
          </mdb-row>

          <mdb-row class="justify-content-center align-items-center">
            <mdb-col md="3" class="text-center" style="margin-bottom: 20px">
              <Btn
                type="primary"
                @onClick="$router.push('/home/curp')"
                text="Iniciar"
              />
            </mdb-col>
          </mdb-row>

          <mdb-row>
            <mdb-col class="text-center">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot dot-colored"></span>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col class="text-left">
              <div @click="welcomescreen--" style="cursor: pointer">
                <img
                  src="/img/icons/arrow-right-grey.svg"
                  style="
                    transform: rotate(180deg);
                    padding-top: 0.6rem;
                    padding-left: 3px;
                  "
                  alt
                />
                <p
                  style="
                    display: inline;
                    font-weight: 300;
                    font-size: 18px;
                    color: #828282;
                  "
                >
                  Atrás
                </p>
              </div>
            </mdb-col>
          </mdb-row>
        </div>
        <!-- welcomescreen 2 -->
      </mdb-container>
    </Popup>
    <Popup ref="videohelp" size="md-mod">
      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half">
        <iframe class="embed-responsive-item" :src="urlVideo"></iframe>
      </div>
    </Popup>

    <Popup size="sm" ref="updateCon">
      <div class="text-center">
        <mdb-row>
          <mdb-col>
            <mdb-row>
              <div
                style="
                  font-family: Josefin Sans;
                  font-size: 19px;
                  font-weight: 600;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  text-align: center;
                  color: #dc7134;
                "
              >
                PRIMERO CORRIGE LOS DATOS DEL PASO SOLICITUD CREADA
              </div>
            </mdb-row>
            <mdb-row class="mt-5">
              <div
                style="
                  font-family: Open Sans;
                  font-size: 17px;
                  font-weight: normal;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  letter-spacing: normal;
                  color: #4f4f4f;
                  text-align: center;
                  padding: 0rem 2rem;
                "
              >
                Primero debes de corregir los datos del paso Solicitud creada,
                donde se encuentran datos y documentos tuyos y de tu trámite,
                después podrás continuar con los de tu Cónyuge.
              </div>
            </mdb-row>
            <mdb-row style="margin-top: 5rem">
              <div class="divLine"></div>
            </mdb-row>
            <mdb-row class="mt-3">
              <div style="margin-left: 40%">
                <Btn
                  @onClick="$refs.updateCon.toggleModal()"
                  :text="'OK'"
                  :type="'primary-admin'"
                ></Btn>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>
  </div>
</template>
<script>
import { mdbContainer, mdbRow, mdbCol, mdbPopover, mdbTbl } from "mdbvue";
import Popup from "../core/Popup";
import Btn from "../core/Button";
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "HomeScreen",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbPopover,
    mdbTbl,
    Btn,
    Popup,
  },
  data() {
    return {
      btnState: "disabled",
      requestIcon: "edit-default.svg",
      paymentIcon: "edit-default.svg",
      uploadDocsIcon: "watch-default.svg",
      requestSpanText: "Ver detalles",
      paymentSpanText: "Editar detalles",
      uploadSpanText: "Ver detalles",
      welcomescreen: 1,
      appId: false,
      payAprob: false,
      urlVideo: "",
      documentsUp: false, //HERE_1:
    };
  },
  mounted() {},
  async created() {
    await this.getApplicationData();
    if (
      this.solicitud.application.applicationStatus ==
      "IN_EDIT_BY_PARTNER_SERVICE"
    ) {
      if (this.solicitud.correcting) {
        if (this.correctionsSpouse.length > 0) {
          this.$refs.updateCon.toggleModal();
        }
      }
    }
  },
  methods: {
    ...mapActions(["checkApplication"]),
    async getApplicationData() {
      try {
        let response = await this.checkApplication();
        // this.solicitud = response.data.data;
        // //console.log(this.solicitud)

        if (response.data.data.application) {
          if (response.data.data.application.applicationStatus == "ACCEPTED") {
            this.documentsUp = true;
          }
          if (response.data.data.application.applicationNumber != null) {
            this.appId = true;
          } else {
            //show only once welcome message

            if (localStorage.getItem("welcome_message") === null) {
              this.$refs.welcomemes.toggleModal();
              localStorage.setItem("welcome_message", true);
            }
          }
          if (
            response.data.data.application.payment &&
            response.data.data.application.payment.paymentStatus == "APPROVED"
          ) {
            this.payAprob = true;
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        //console.log(e);
      }
    },
    seeApplicationDetails() {
      Swal.fire({
        title:
          "<span style='font-size: 20px; font-family: Josefin Sans; color: #828282'>¡Detalles de tu solicitud!</span>",
        html:
          "<div style='text-align: initial; padding-left: 7rem; padding-top: 1rem; font-size: 13px; font-family: Open Sans' color: #828282'>" +
          "<p>Solicitud generada a nombre de: <span style='padding: 5px; background-color: #3a8a65; color: #fff; font-weight: 600;'>" +
          this.nombre +
          " " +
          this.lastName +
          " " +
          this.motherLastName +
          "</span> </p>" +
          "<p style='padding-top: 1rem;'>Con número de solicitud: <span style='padding: 5px; background-color: #3a8a65; color: #fff; font-weight: 600;'>" +
          this.applicationId +
          "</span></p>" +
          "</div>",
        allowOutsideClick: false,
        width: 600,
        padding: "4em",
        confirmButtonColor: "#dc7134",
        confirmButtonText: "Ok",
        onClose: () => {},
      });
    },
    mouseOverIcon(module) {
      if (module == "request") {
        let requestIcon = this.requestIcon.split("-");
        this.requestIcon = `${requestIcon[0]}-hover.svg`;
      } else if (module == "payment") {
        let paymentIcon = this.paymentIcon.split("-");
        this.paymentIcon = `${paymentIcon[0]}-hover.svg`;
      } else if (module == "upload") {
        let uploadDocsIcon = this.uploadDocsIcon.split("-");
        this.uploadDocsIcon = `${uploadDocsIcon[0]}-hover.svg`;
      }
    },
    mouseLeaveIcon(module) {
      if (module == "request") {
        let requestIcon = this.requestIcon.split("-");
        this.requestIcon = `${requestIcon[0]}-default.svg`;
      } else if (module == "payment") {
        let paymentIcon = this.paymentIcon.split("-");
        this.paymentIcon = `${paymentIcon[0]}-default.svg`;
      } else if (module == "upload") {
        let uploadDocsIcon = this.uploadDocsIcon.split("-");
        this.uploadDocsIcon = `${uploadDocsIcon[0]}-default.svg`;
      }
    },
    mouseDownIcon(module) {
      if (module == "request") {
        let requestIcon = this.requestIcon.split("-");
        this.requestIcon = `${requestIcon[0]}-click.svg`;
      } else if (module == "payment") {
        let paymentIcon = this.paymentIcon.split("-");
        this.paymentIcon = `${paymentIcon[0]}-click.svg`;
      } else if (module == "upload") {
        let uploadDocsIcon = this.uploadDocsIcon.split("-");
        this.uploadDocsIcon = `${uploadDocsIcon[0]}-click.svg`;
      }
    },
    mouseUpIcon(module) {
      if (module == "request") {
        let requestIcon = this.requestIcon.split("-");
        this.requestIcon = `${requestIcon[0]}-hover.svg`;
      } else if (module == "payment") {
        let paymentIcon = this.paymentIcon.split("-");
        this.paymentIcon = `${paymentIcon[0]}-hover.svg`;
      } else if (module == "upload") {
        let uploadDocsIcon = this.uploadDocsIcon.split("-");
        this.uploadDocsIcon = `${uploadDocsIcon[0]}-hover.svg`;
      }
    },
    openVideo(url) {
      this.urlVideo = url;
      this.$refs.videohelp.toggleModal();
    },
  },
  computed: {
    ...mapGetters({
      applicationId: "getApplicationID",
      paymentApproved: "getPaymentApproved",
      welcomeMessage: "getWelcomeMessage",
      maritalStatus: "getMaritalStatus",
      beneficiaries: "getBeneficiariesData",
      nombre: "getName",
      lastName: "getLastName",
      motherLastName: "getMothersLastName",
      app: "getApplication",
      titularDocs: "getDocuments",
      solicitud: "getAllApplicationData",
    }),
    corrections() {
      let corrections = [];
      this.solicitud.application.corrections.forEach((item) => {
        if (item.editAt === null) {
          corrections.push(JSON.parse(item.jsonCorrections));
        }
      });
      return corrections;
    },
    correctionsSpouse() {
      let correctionsSpouse = [];
      this.solicitud.application.corrections.forEach((item) => {
        if (item.editAt === null) {
          var aux = JSON.parse(item.jsonCorrections);
          aux.beneficiaries.forEach((item2) => {
            if (item2.beneficiaryType === "SPOUSE") {
              correctionsSpouse.push(item2);
            }
          });
        }
      });

      return correctionsSpouse;
    },
    hasApplicationId() {
      return this.applicationId !== "N/A" && this.applicationId !== null
        ? true
        : false;
    },
    treeImg() {
      if (this.solicitud) {
        if (
          this.solicitud.application.membership &&
          this.solicitud.application.membership.membershipName == "Familiar" &&
          this.solicitud.maritalStatus == "MARRIED"
        ) {
          if (this.beneficiaries.length > 0) {
            if (
              this.solicitud.application.applicationStatus ==
                "RESEARCH_FINISHED" ||
              this.solicitud.application.applicationStatus ==
                "IN_REVIEW_BY_PARTNER_SERVICE" ||
              this.solicitud.application.applicationStatus ==
                "IN_REVIEW_BY_COMMITTEE" ||
              this.solicitud.application.applicationStatus == "ACCEPTED" ||
              this.solicitud.application.applicationStatus == "DECLINED"
            ) {
              return "/img/tree/Wizard2-Conyuge-02.svg";
            }
            if (
              this.solicitud.application.applicationStatus ==
              "DOCUMENTATION_FINISHED"
            ) {
              return "/img/tree/Wizard2-Conyuge-03.svg";
            }
            if (this.solicitud.application.applicationStatus == "FINISHED") {
              return "/img/tree/Wizard2-Conyuge-Completo.svg";
            }

            if (
              this.solicitud.application.applicationStatus == "IN_EDIT_ACCEPTED"
            ) {
              return "/img/tree/Wizard2-Conyuge-07.svg";
            }
            if (
              this.solicitud.application.applicationStatus ==
              "IN_EDIT_BY_PARTNER_SERVICE"
            ) {
              if (this.solicitud.correcting) {
                if (this.correctionsSpouse.length > 0) {
                  return "/img/tree/Wizard2-Conyuge-05.svg";
                } else {
                  return "/img/tree/Wizard2-Conyuge-04.svg";
                }
              } else {
                return "/img/tree/Wizard2-Conyuge-06.svg";
              }
            } else return "/img/tree/Wizard2-Conyuge-08.svg";
          } else {
            if (
              this.solicitud.application.payment &&
              this.solicitud.application.payment.paymentStatus == "APPROVED"
            )
              return "/img/tree/Wizard2-Conyuge-01.svg";
            else return "/img/tree/Wizard2-Soltero-02.svg";
          }
        } else {
          if (
            this.solicitud.application.payment &&
            this.solicitud.application.payment.paymentStatus == "APPROVED"
          ) {
            if (
              this.solicitud.application.applicationStatus ==
                "RESEARCH_FINISHED" ||
              this.solicitud.application.applicationStatus ==
                "IN_REVIEW_BY_PARTNER_SERVICE" ||
              this.solicitud.application.applicationStatus ==
                "IN_REVIEW_BY_COMMITTEE" ||
              this.solicitud.application.applicationStatus == "ACCEPTED" ||
              this.solicitud.application.applicationStatus == "DECLINED"
            ) {
              return "/img/tree/Wizard2-Soltero-03.svg";
            }
            if (
              this.solicitud.application.applicationStatus ==
              "DOCUMENTATION_FINISHED"
            ) {
              return "/img/tree/Wizard2-Soltero-04.svg";
            }
            if (this.solicitud.application.applicationStatus == "FINISHED") {
              return "/img/tree/Wizard2-Soltero-Completo.svg";
            }
            if (
              this.solicitud.application.applicationStatus ==
              "IN_EDIT_BY_PARTNER_SERVICE"
            ) {
              return "/img/tree/Wizard2-Soltero-05.svg";
            }
            if (this.solicitud.application.applicationStatus == "CREATED") {
              return "/img/tree/Wizard2-Soltero-03.svg";
            } else return "/img/tree/Wizard2-Soltero-06.svg";
          } else {
            return "/img/tree/Wizard2-Soltero-02.svg";
          }
        }
      } else {
        return "/img/tree/Wizard2-Soltero-01.svg";
      }
    },
    // spouseData(){
    //   let spouse = this.beneficiaries.filter(function (item) {
    //     return item.beneficiaryType == "SPOUSE";
    //   });
    //   if(spouse.length >0)
    //       return spouse[0]
    //   else
    //     return null
    // },
    // spouseCurp(){
    //    let spouse = this.spouseData.documents.filter(function (item) {
    //     return item.documentType == "CURP";
    //   });
    //   if(spouse.length >0)
    //       return spouse[0]
    //   else
    //     return null

    // },
    titularCurp() {
      let spouse = this.titularDocs.filter(function (item) {
        return item.documentType == "CURP";
      });

      if (spouse.length > 0) return spouse[0];
      else return null;
    },
    titularPic() {
      let spouse = this.titularDocs.filter(function (item) {
        return item.documentType == "PROFILE_PICTURE";
      });

      if (spouse.length > 0) return spouse[0];
      else return null;
    },
    titularRecomendations() {
      let correction = this.solicitud.recommendations.filter(function (item) {
        return item.commentApplicant != null;
      });
      if (correction.length > 0) {
        return true;
      } else return false;
    },
  },
};
</script>
<style>
::-webkit-scrollbar {
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #dc7134;
  border-radius: 10px;
}
</style>
<style lang="scss">
.btn-submit-home {
  padding-right: 12rem;
  text-align: right;

  @media (max-width: 50rem) {
    padding-right: 2rem;
  }
}

.dot {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  display: inline-block;
  background-color: #c4c4c4;
  margin: 3px;
}

.dot-colored {
  background-color: #dc7134;
}

.option_text {
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: normal;
  color: #4f4f4f !important;
  font-family: Open Sans;
  text-align: left;
  position: relative;
  margin-top: 20px;
}

.option_text .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: #3a8a65 !important;
  position: absolute;
  left: -20px;
  top: 0px;
}

.option_text strong {
  font-weight: 600;
}

.divLine {
  width: 100%;
  border: 0.1rem solid #828282;
}
</style>